"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = require("react");

var _react2 = _interopRequireDefault(_react);

var _propTypes = require("prop-types");

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactMotion = require("react-motion");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var AnimatedWrapper = function AnimatedWrapper(_ref) {
  var children = _ref.children,
      height = _ref.height,
      onRest = _ref.onRest;
  return _react2.default.createElement(
    _reactMotion.Motion,
    { defaultStyle: { height: 0 }, style: { height: height }, onRest: onRest },
    children
  );
};

AnimatedWrapper.propTypes = {
  children: _propTypes2.default.func,
  height: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.object]),
  onRest: _propTypes2.default.func
};

exports.default = AnimatedWrapper;